module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI2IDI1Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiPgogICAgPHBhdGggZD0iTTAuMjc5NzA1MTAyLDI0LjIyMDI5NDkgTDIzLjc1MTA5NzMsMC43NDg5MDI3MzciLz4KICAgIDxwYXRoIGQ9Ik0wLjI3OTcwNTEwMiwyNC4yMjAyOTQ5IEwyMy43NTEwOTczLDAuNzQ4OTAyNzM3IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyNC4wMyAwKSIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/menu-close.svg
// module id = 49
// module chunks = 168707334958949